import { httpCreate } from './http';

const http = httpCreate('/srv/volc-upload');

export const volcUpload = {
	getToken(activityId) {
		return http.get(`/sign/${activityId}`);
	},
};
